import React, { FC } from "react";
import { connect } from "react-redux";
import { State } from "../../../store";
import { Link, useLocation } from "react-router-dom";
import * as SofViewStore from "../../../store/SofViewStore";
import * as GeneralStore from "../../../store/GeneralStore";
import { capitalizeFirstLetterPerWord } from "../../../services/Helper";
import moment from 'moment';

type Props = GeneralStore.GeneralState &
    typeof SofViewStore.actionCreators & {
        nomination: any;
    };

const NominationItem: FC<Props> = (props: Props) => {
    const { nomination } = props;
    const location = useLocation();
    const lastUpdatedFromNow = moment(nomination.updatedAt).fromNow();
    return (
        <Link
            className="col-4 p-3"
            id={`lnk-${nomination.nominationNo}`}
            to={`${location.pathname}/${nomination.nominationNo}/sof`}
        >
            <div className="p-3 mb-1 d-flex bg-white tank-item">
                <img alt={`Tank Level ${((nomination.criticalMeasurements.level.processValue / nomination.criticalMeasurements.level.valueMax) * 10).toFixed(0)}`} src={`tank-levels/tank-level-${((nomination.criticalMeasurements.level.processValue / nomination.criticalMeasurements.level.valueMax) * 10).toFixed(0) }.svg`} />
                <div className="d-flex flex-column justify-content-between gap" style={{ flex: 1 }}>
                    <div className="d-flex">
                        <div>
                            <div className="item-header">{nomination.name}</div>
                            <div className="text-secondary item-sub-details-suffix">{nomination.brand}</div>
                            <div className="item-sub-details-suffix text-slate-600">{nomination.chemical}</div>
                        </div>
                        {nomination.mode === 'IDLE' && (<div>
                            <div className="d-flex">
                                <div className="value-tank-status">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <mask id="mask0_394_16976" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                                            <rect width="16" height="16" fill="#D9D9D9" />
                                        </mask>
                                        <g mask="url(#mask0_394_16976)">
                                            <path d="M10.2333 10.8329L11.0833 9.98294L8.59998 7.49961V3.99961H7.39998V7.99961L10.2333 10.8329ZM7.99998 14.3996C7.11798 14.3996 6.28914 14.2329 5.51348 13.8996C4.73781 13.5663 4.05831 13.1079 3.47498 12.5246C2.89164 11.9413 2.43331 11.2609 2.09998 10.4836C1.76664 9.70628 1.59998 8.87572 1.59998 7.99194C1.59998 7.10817 1.76664 6.27739 2.09998 5.49961C2.43331 4.72183 2.89164 4.04405 3.47498 3.46628C4.05831 2.8885 4.73864 2.43294 5.51598 2.09961C6.29331 1.76628 7.12386 1.59961 8.00764 1.59961C8.89142 1.59961 9.72225 1.76761 10.5001 2.10361C11.2779 2.43961 11.9545 2.89561 12.53 3.47161C13.1053 4.04761 13.5608 4.72494 13.8965 5.50361C14.2321 6.28228 14.4 7.11428 14.4 7.99961C14.4 8.88161 14.2333 9.71044 13.9 10.4861C13.5666 11.2618 13.1111 11.9413 12.5333 12.5246C11.9555 13.1079 11.277 13.5663 10.4978 13.8996C9.71859 14.2329 8.88598 14.3996 7.99998 14.3996ZM8.00798 13.1996C9.44653 13.1996 10.6715 12.6913 11.683 11.6746C12.6943 10.6579 13.2 9.43028 13.2 7.99161C13.2 6.55305 12.6943 5.32805 11.683 4.31661C10.6715 3.30528 9.44653 2.79961 8.00798 2.79961C6.56931 2.79961 5.34164 3.30528 4.32498 4.31661C3.30831 5.32805 2.79998 6.55305 2.79998 7.99161C2.79998 9.43028 3.30831 10.6579 4.32498 11.6746C5.34164 12.6913 6.56931 13.1996 8.00798 13.1996Z" fill="white" />
                                        </g>
                                    </svg>
                                    {capitalizeFirstLetterPerWord(nomination.mode)}
                                </div>
                            </div>
                        </div>)}
                    </div>
                    <table>
                        <tbody>
                            <tr>
                                <td className="item-sub-details" style={{ width: 2 }}>
                                    <img width={18} height={18} alt="temperature" src="/tank-critical-measurements/icon-temperature.svg" />
                                </td>
                                <td>
                                    <div className="d-flex align-items-center">
                                        <div className="item-sub-details pr-1">{nomination.temp_f}</div>
                                        <div className="text-secondary item-sub-details-suffix">&#8457;</div>
                                    </div>
                                </td>
                                <td className="item-sub-details" style={{ width: 2 }}>
                                    <img width={14} height={14} alt="level" src="/tank-critical-measurements/icon-level.svg" />
                                </td>
                                <td>
                                    <div className="d-flex align-items-center">
                                        <div className="item-sub-details pr-1">{nomination.criticalMeasurements.level.processValue.toFixed(2)}</div>
                                        <div className="text-secondary item-sub-details-suffix">FT</div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="item-sub-details" style={{ width: 2 }}>
                                    <img width={18} height={18} alt="pressure" src="/tank-critical-measurements/icon-pressure.svg" />
                                </td>
                                <td className="mr-3">
                                    <div className="d-flex align-items-center">
                                        <div className="item-sub-details pr-1">
                                            {nomination.temp_c}
                                        </div>
                                        <div className="text-secondary item-sub-details-suffix">WC''</div>
                                    </div>
                                </td>
                                <td className="item-sub-details" style={{ width: 2 }}>
                                    <img width={14} height={14} alt="flow" src="/tank-critical-measurements/icon-flow.svg" />
                                </td>
                                <td className="mr-3">
                                    <div className="d-flex align-items-center">
                                        <div className="item-sub-details pr-1">
                                            {nomination.temp_h}
                                        </div>
                                        <div className="text-secondary item-sub-details-suffix">PBH</div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="text-sm text-slate-500">
                        <span>Data Status:</span>
                        <span> {lastUpdatedFromNow === 'a few seconds ago' ? 'Up to date' : `Last updated ${lastUpdatedFromNow}`} </span>
                    </div>
                </div>
            </div>
        </Link>
    );
};
export default connect(
    (state: State) => ({
        ...state.general,
    }),
    SofViewStore.actionCreators
    // @ts-ignore
)(NominationItem);
